import React from 'react';
import { parseBhriguReply, splitInlineFormatting } from '../../lib/bhriguReplyFormat';

/**
 * @param {{ text: string; isDark: boolean }} props
 */
function InlineText({ text, isDark }) {
  const parts = splitInlineFormatting(text);
  return (
    <>
      {parts.map((part, i) =>
        part.type === 'bold' ? (
          <strong key={i} className={isDark ? 'font-semibold text-gray-50' : 'font-semibold text-gray-900'}>
            {part.value}
          </strong>
        ) : (
          <span key={i}>{part.value}</span>
        ),
      )}
    </>
  );
}

/**
 * @param {{ content: string; isDark: boolean }} props
 */
export function BhriguReplyContent({ content, isDark }) {
  const blocks = parseBhriguReply(content);
  const listClass = isDark ? 'text-gray-100' : 'text-gray-900';

  return (
    <div className="space-y-2.5">
      {blocks.map((block, i) => {
        if (block.type === 'ol' && block.items) {
          return (
            <ol key={i} className={`list-decimal space-y-1.5 pl-4 ${listClass}`}>
              {block.items.map((item, j) => (
                <li key={j} className="pl-0.5 leading-relaxed">
                  <InlineText text={item} isDark={isDark} />
                </li>
              ))}
            </ol>
          );
        }
        if (block.type === 'ul' && block.items) {
          return (
            <ul key={i} className={`list-disc space-y-1.5 pl-4 ${listClass}`}>
              {block.items.map((item, j) => (
                <li key={j} className="pl-0.5 leading-relaxed">
                  <InlineText text={item} isDark={isDark} />
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i} className={`leading-relaxed ${listClass}`}>
            <InlineText text={block.text || ''} isDark={isDark} />
          </p>
        );
      })}
    </div>
  );
}
